import "@babel/polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import 'vuetify/dist/vuetify.min.css';
import Http from "./service/Http";
import i18n from "@/plugins/i18n";

import axios from "axios";
import VueAxios from "vue-axios";
import cssVars from 'css-vars-ponyfill';
import configPlugin from '@/plugins/config';

cssVars({})
Vue.use(VueAxios, axios);
Vue.use(configPlugin);

Vue.config.productionTip = false;

// 把 Http 掛載到 Vue 實例上
Vue.prototype.$Http = Http

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app");
